import Cookies from 'js-cookie'
import _ from 'lodash'
import { useEffect } from 'react'

const setUrlHashAndCookie = (filter) => {
  let hashStr = ''
  Object.keys(filter).forEach((key) => {
    if (filter[key]) hashStr += `#${filter[key]}`
    filter[key] && Cookies.set(key, filter[key], { path: '' })
    !filter[key] && Cookies.remove(key, { path: '' })
  })
  window.location.hash = hashStr
}

export const useHashUrlFilter = (
  selectedCategories,
  subCategories,
  subCategoriesTwo,
  type,
  typeTwo,
  onClick
) => {
  useEffect(() => {
    if (!_.isEmpty(selectedCategories)) {
      setUrlHashAndCookie(selectedCategories)
    } else if (
      (window.location.hash !== '' ||
        Cookies.get(type) !== undefined ||
        Cookies.get(typeTwo) !== undefined) &&
      subCategories.length !== 0 &&
      (!typeTwo || !(subCategoriesTwo.length === 0))
    ) {
      const urlHash = decodeURIComponent(window.location.hash)
      const initFilterArray = urlHash.split('#').filter((s) => s)
      const initFilters = {}
      if (initFilterArray.length === 0) {
        initFilterArray.unshift(Cookies.get(type))
        typeTwo && initFilterArray.unshift(Cookies.get(typeTwo))
      }
      initFilterArray.forEach((hash) => {
        if (_.find(subCategories, { description: hash })) {
          initFilters[type] = hash
        }
      })

      if (typeTwo) {
        initFilterArray.forEach((hash) => {
          if (_.find(subCategoriesTwo, { description: hash })) {
            initFilters[typeTwo] = hash
          }
        })
      }
      if (!_.isEmpty(initFilters)) {
        onClick(initFilters)
      }
    }
  }, [
    onClick,
    selectedCategories,
    subCategories,
    subCategoriesTwo,
    type,
    typeTwo,
  ])
}
